import t from 'react-translate';
import React from 'react';
import { css } from '@emotion/react';

import NvIcon from 'shared/components/nv-icon';
import ClickableContainer from 'components/clickable-container';
import { halfSpacing, tooltipZIndex } from 'styles/global_defaults/scaffolding';
import { gray4, primary, warning, white } from 'styles/global_defaults/colors';
import NvTooltip from './nv-tooltip';

type Props = {
  onUp?: () => void;
  onDown?: () => void;
  disabledUp?: boolean;
  disabledDown?: boolean;
  showTooltipOnDisabledUp?: boolean;
  tooltipTextOnDisabledUp?: string;
  showTooltipOnDisabledDown?: boolean;
  tooltipTextOnDisabledDown?: string;
  className?: string;
};

const NumberInputArrows = (props: Props) => {
  const {
    onUp,
    onDown,
    disabledUp,
    disabledDown,
    showTooltipOnDisabledUp = false,
    tooltipTextOnDisabledUp,
    showTooltipOnDisabledDown = false,
    tooltipTextOnDisabledDown,
    className,
  } = props;

  const styles = css`
    overflow: hidden;
    border-radius: 4px;

    .arrow-container {
      width: 22px;
      height: 12px;
      outline-color: ${warning}!important;
      background-color: ${primary};

      &:first-child {
        margin-bottom: 2px;
      }

      .icon {
        color: ${white};
        font-size: ${halfSpacing}px;
      }
      &.disabled {
        cursor: not-allowed;
        background-color: ${gray4};
      }
    }
  `;

  return (
    <div className={`d-flex flex-column ${className ?? ''}`} css={styles}>
      <NvTooltip
        enabled={showTooltipOnDisabledUp && disabledUp}
        text={tooltipTextOnDisabledUp}
        zIndex={tooltipZIndex}
        className='visible'
        placement='top'
      >
        <ClickableContainer
          onClick={disabledUp ? undefined : onUp}
          disabled={disabledUp}
          className={`d-flex justify-content-center align-items-center arrow-container ${disabledUp ? 'disabled' : ''}`}
          aria-label={t.SHARED.NUMBER_INPUT.ARIA_LABEL.INCREASE_NUMBER()}
        >
          <NvIcon icon='arrow-up' size='' />
        </ClickableContainer>
      </NvTooltip>
      <NvTooltip
        enabled={showTooltipOnDisabledDown && disabledDown}
        text={tooltipTextOnDisabledDown}
        zIndex={tooltipZIndex}
        className='visible'
        placement='top'
      >
        <ClickableContainer
          onClick={disabledDown ? undefined : onDown}
          disabled={disabledDown}
          className={`d-flex justify-content-center align-items-center arrow-container ${disabledDown ? 'disabled' : ''}`}
          aria-label={t.SHARED.NUMBER_INPUT.ARIA_LABEL.DECREASE_NUMBER()}
        >
          <NvIcon icon='arrow-down' size='' />
        </ClickableContainer>
      </NvTooltip>
    </div>
  );
};

export default NumberInputArrows;
